module.exports = __webpack_public_path__ + "media/images/new-32-a6d19d8fa9b1705284d2c900fe27f871.png";